import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LayoutComponent implements OnInit, AfterViewInit, OnDestroy {

  routingParam

  constructor(session: StorageService,
    @Inject(DOCUMENT) private document: Document,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.content = session.resource?.landing;
    this.routingParam = this.route.snapshot['_routerState'].url;

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      this.routingParam = this.route.snapshot['_routerState'].url;
      this.setActiveBgClass(this.routingParam);
    });
  }
  content;
  activeRoute: string;

  activeBgClass = '';
  activeHueClass = '';
  private readonly layoutRoutes = new Set(['/setup', '/rgm', '/seg', '/rtm', '/reports', '/red']);

  ngOnInit(): void {

  }

  private setActiveBgClass(route: string): void {
    this.activeBgClass = this.layoutRoutes.has(route) ? 'layout-bg' : 'clear-bg';
    this.activeHueClass = this.getHueClass(route);
  }

  getHueClass(route: string): string {
    if(route === '/setup') {
      return 'hue-setup';
    }
    if (route === '/rgm') {
      return 'hue-rgm';
    }
    if (route === '/seg') {
      return 'hue-seg';
    }
    if (route === '/rtm') {
      return 'hue-rtm';
    }
    if (route === '/reports') {
      return 'hue-reports';
    }
    if (route === '/red') {
      return 'hue-red';
    }
    return '';
  }

  getFirstPath(route: ActivatedRoute): string | null {
    let child = route.firstChild;
    while (child?.firstChild) {
      child = child.firstChild;
    }
    return child?.routeConfig?.path ?? null;
  }

  ngAfterViewInit(): void {
    // Adding style class on body for dashboard page.
    this.document.body.classList.add('header-mobile-fixed', 'subheader-enabled', 'aside-enabled', 'aside-fixed');
  }

  ngOnDestroy(): void {
    this.document.body.className = '';
  }

  private buildFullRoutePath(route: ActivatedRoute, pathParts: string[] = []): string {
  if (route.routeConfig?.path) {
    pathParts.push(route.routeConfig.path);
  }

  if (route.firstChild) {
    return this.buildFullRoutePath(route.firstChild, pathParts);
  }

  return pathParts.join('/');
}



}
